module.exports = __webpack_public_path__ + "assets/img/landing-top-notebook_new.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-top-notebook_new.png
// module id = 1948
// module chunks = 0